import dictionaryData from "../../words";

const initialState = [];

const dictionaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_DICTIONARY":
      if (action.payload === "") {
        return [];
      } else {
        const regex = new RegExp(`^${action.payload.toLowerCase()}.*`);
        return dictionaryData.filter(x => regex.test(x.searchForm));
      }
    default:
      return state;
  }
};

export default dictionaryReducer;



// WEBPACK FOOTER //
// ./src/apps/vocabularium/data/redux/reducers/dictionary.js